<template>
  <div>
    <transition
      name="error-transition"
      enter-active-class="error-enter-active"
      leave-active-class="error-leave-active"
    >
      <div v-if="showError" :key="randomKey" class="error flex items-center mb-1">
        <OSvg svg="danger" class="fill-red-300 mr-1" width="14" />
        <span class="o-caption text-red-300" v-text="errorMessage" />
      </div>
    </transition>
    <OCheckBox
      :value="value"
      name="consent"
      @input="onInput"
    >
      <i18n tag="span" class="o-caption pl-rem" path="SignUp.StepFive.NewConsent">
        <template #termsAndConditions>
          <button class="text-neutral-800 underline" type="button" @click="openTermsAndConditions">
            {{ $t('SignUp.OnePage.LinkWords.TermsAndConditions') }}
          </button>
        </template>
      </i18n>
    </OCheckBox>
    <TermsAndConditionsModal
      ref="TermsAndConditionsModal"
    />
  </div>
</template>

<script>
import OCheckBox from '@/components/OCheckBox'
import OSvg from '@/components/OSvg'
import TermsAndConditionsModal from '@/components/Modals/TermsAndConditionsModal'

export default {
  name: 'SignupConsent',
  components: {
    OCheckBox,
    TermsAndConditionsModal,
    OSvg
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showError: false,
      randomKey: `${new Date().toLocaleTimeString()}--${Math.random()}`
    }
  },
  watch: {
    value (newValue, oldValue) {
      if (newValue !== oldValue && this.showError) {
        this.showError = false
      }
    }
  },
  methods: {
    onInput ($event) {
      this.$emit('input', $event.target.checked)
      if ($event.target.checked) {
        this.showError = false
      }
    },
    openTermsAndConditions () {
      this.$refs.TermsAndConditionsModal.toggleActivation(true)
    },
    triggerError () {
      this.showError = true
      this.randomKey = `${new Date().toLocaleTimeString()}--${Math.random()}`
    }
  }
}
</script>

<style lang="postcss" scoped>
@keyframes vibrate {
  0% { transform: translate(0); }
  20% { transform: translate(-2px, 2px); }
  40% { transform: translate(-2px, -2px); }
  60% { transform: translate(2px, 2px); }
  80% { transform: translate(2px, -2px); }
  100% { transform: translate(0); }
}

.error-enter-active {
  animation: vibrate 0.5s ease-in-out;
  transform-origin: left center;
}

.error-enter-active .error {
  animation: scale-up 0.3s ease-out;
}

@keyframes scale-up {
  0% { transform: scale(0.95); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}
</style>
